import React from 'react'
import { Header, Label, Image } from 'semantic-ui-react';
import { Form, Dropdown } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';

const options = [
    { text: 'All', value: 'all' },
    // { text: 'My', value: 'my' }
];

class CountCardHeader extends React.Component {
    showDataByType(key, values) {
        if (this.props.type === 'content') {
            let payload = {}
            payload.organizationId = this.props.selectedOrganisation.id;
            payload.value = values.value;
            dispatch.content.getContentsCount(payload);
        }

        if (this.props.type === 'initiative') {
            let payload = {}
            payload.organizationId = this.props.selectedOrganisation.id;
            payload.showMyDasboardData = false;
            if (values.value === 'my') {
                payload.showMyDasboardData = true;
            }
            dispatch.initiatives.getinitiativesCountProxy(payload);
        }

        if (this.props.type === 'playbook') {
            let payload = {}
            payload.id = this.props.selectedOrganisation.id;
            payload.showMyDasboardData = false;
            if (values.value === 'my') {
                payload.showMyDasboardData = true;
            }
            dispatch.lifeCycle.getCounts(payload)
        }

        if (this.props.type === 'community') {
            let payload = {}
            payload.id = this.props.selectedOrganisation.id;
            payload.showMyDasboardData = false;
            if (values.value === 'all') {
                dispatch.organizationUnit.getOrganizationCount({ organizationId: this.props.selectedOrganisation.id, accountId: this.props.selectedAccount._id })
                payload.showMyDasboardData = true;
            }
            else if (values.value === 'my') {
                dispatch.organizationUnit.myCommunityDashboardCount({ organizationId: this.props.selectedOrganisation.id, accountId: this.props.selectedAccount._id })
                payload.showMyDasboardData = true;
            }
            // dispatch.lifeCycle.getCounts(payload)
        }

    }

    render() {
        const errorLabel = <Label color="red" pointing="left" />;

        return (
            <div className="count-header" >
                <Header as='h5' floated='left' >
                    <Image src={this.props.image} />
                    <label>
                        {this.props.name}
                    </label>
                    {this.props.type !== "community" ?
                        <Label size="mini">
                            {this.props.totalCount ? this.props.totalCount : 0}
                        </Label> : ""}
                </Header>

            </div>
        )
    }
}

export default CountCardHeader;